<form class="space-y-3 sm:space-y-4 w-full max-w-full" (submit)="guardar($event)">
  <div>
    <label class="block text-sm font-medium text-gray-700">Nombre</label>
    <input [formField]="$any(formTipoPago.nombre)" class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
  </div>

  <div>
    <label class="block text-sm font-medium text-gray-700">Tipo de transacción</label>
    <app-select
      [filter]="true"
      filterBy="label,value"
      emptyFilterMessage="No se encontraron tipos de transacción."
      [formField]="$any(formTipoPago.tipo_transaccion)"
      [options]="opcionesTipoTransaccion()"
      [loading]="!opcionesTipoTransaccion().length"
      class="w-full"
    />
  </div>

  <div class="flex justify-end gap-2 pt-4">
    <button
      type="button"
      class="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium"
      (click)="cancelar()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-medium"
    >
      Guardar
    </button>
  </div>
</form>
